import React from 'react'
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'

const accessOrder = [
  'customers',
  'customer onboarder',
  'customers - user specific',
  'customer - sales person reassign',
  'invoices',
  'orders',
  'orders - user specific',
  'products',
  'sales person',
  'users',
]

const childToParent = {
  'customer onboarder': 'customers',
  'customers - user specific': 'customers',
  'customer - sales person reassign': 'customers',
  'orders - user specific': 'orders',
}

const parentToChildren = {
  customers: ['customer onboarder', 'customers - user specific', 'customer - sales person reassign'],
  orders: ['orders - user specific'],
}

const labels = {
  'customer onboarder': 'CUSTOMER - ONBOARDER',
  'customer - sales person reassign': 'CUSTOMER - SALES PERSON REASSIGN',
}

const descriptions = {
  customers: 'View and manage customers',
  'customer onboarder': 'Create and onboard new customers',
  'customers - user specific': 'View only assigned customers',
  'customer - sales person reassign': 'Allow reassignment to another sales person',
  invoices: 'View and manage invoices',
  orders: 'View and manage orders',
  'orders - user specific': 'View only orders for assigned customers',
  products: 'View and manage products',
  'sales person': 'Show this user in the sales person selection list',
  users: 'View and manage users and permissions',
}

const AccessControlList = ({ value, onChange }) => {
  const toggle = (key) => {
    const checked = !value[key]
    const nextValue = { ...value, [key]: checked }
    const parent = childToParent[key]

    if (checked && parent) {
      nextValue[parent] = true
    }

    if (!checked && parentToChildren[key]) {
      parentToChildren[key].forEach((child) => {
        nextValue[child] = false
      })
    }

    onChange(nextValue)
  }

  return (
    <FormGroup sx={{ mt: 1, mb: 2 }}>
      {accessOrder
        .filter((key) => Object.prototype.hasOwnProperty.call(value, key))
        .map((key) => (
          <FormControlLabel
            key={key}
            sx={childToParent[key] ? { ml: 4 } : undefined}
            control={
              <Checkbox
                checked={Boolean(value[key])}
                onChange={() => toggle(key)}
                name={key}
              />
            }
            label={
              <>
                <strong>{labels[key] || key.toLocaleUpperCase()}</strong>
                {' - '}
                <em>{descriptions[key]}</em>
              </>
            }
          />
        ))}
    </FormGroup>
  )
}

export default AccessControlList
